var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ranking-board"}},[_c('div',{staticClass:"ranking-board-title"},[_vm._v("指标预警数量")]),(_vm.config.data.length > 0)?_c('dv-scroll-ranking-board',{attrs:{"config":_vm.config}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }